import { AbstractControl, ValidatorFn } from '@angular/forms';

export function cvv(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (
      control.value === '000' ||
      control.value === '999' ||
      control.value === '0000' ||
      control.value === '9999'
    ) {
      return { invalidCvv: true };
    }
    return null;
  };
}
